import axios from 'axios'
import { API_URL, getAuthHeader } from '@/services/api.service.js'

/**
 * Fetches a page of user notification lists.
 * @param {object} [page] - Page window.
 * @param {'all'|'unread'} [page.filter] - Notification list to read.
 * @param {number} [page.limit] - Maximum notifications to return.
 * @param {number} [page.offset] - Notifications to skip.
 * @returns {Promise<{notifications: Array, totalCount: number, nextOffset: number|null}>} A page, its total, and where the next page starts.
 */
export const fetchNotifications = async ({ filter, limit, offset } = {}) => {
  const response = await axios.get(`${await API_URL()}/notifications/${filter}`, {
    headers: { ...(await getAuthHeader()) },
    params: { limit, offset }
  })

  return response.data
}

/**
 * Downloads a generated export file for the signed-in user.
 * @param {string} boardId - Main board the export was generated from.
 * @param {string} docId - Export document id from the notification's `runArgs.docId`.
 * @returns {Promise<Blob>} The file contents.
 */
export const downloadExportFile = async (boardId, docId) => {
  const response = await axios.get(
    `${await API_URL()}/file-repository/${boardId}/${docId}/export`,
    {
      headers: await getAuthHeader(),
      responseType: 'blob'
    }
  )

  return response.data
}

/**
 * Marks a notification as read
 * @param {string} id - Notification id
 * @returns {Promise<object>} The updated notification
 */
export const markNotificationRead = async (id) => {
  const response = await axios.patch(
    `${await API_URL()}/notifications/${id}/read`,
    {},
    { headers: { ...(await getAuthHeader()) } }
  )

  return response.data
}
